import { Spacing } from '../../theme';

/**
 * Collection of class names inside Checkbox component.
 *
 * These styles basically only mark component in named way in case you want to override styles in parent
 */
export const CheckboxClassNames = {
  Root: 'hc-checkbox-root',
  Label: 'hc-checkbox-label',
  Main: 'hc-checkbox-main',
};

export const CheckboxSpacingKey: keyof Spacing = '5x';
export const CheckboxGapKey: keyof Spacing = '6x';
